import applogo from 'assets/images/choicehotels.jpg'
import onboarding from 'assets/images/TCLogo.jpg'
import FormModal from 'components/organisms/FormModal/FormModal'
import * as FormConst from 'constants/FormConst'
import * as RoleConfigurationConst from 'constants/RoleConfigurationConst'
import SessionConst from 'constants/SessionConst'
import { isEmptyObject } from 'jquery'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { asyncMethod } from 'redux/actions'
import HotelInfoService from 'services/HotelInfoService'
import { getBrandLogo } from 'utilities/FormHelper'
import { isArrayIncludesAny, isObjectEmpty } from 'utilities/JSUtil'
import { getSessionItem } from 'utilities/SessionHelper'
import RouteConst from '../../constants/RouteConst'
import * as actionTypes from '../../redux/actionTypes'
import Button from '../atoms/Button/Button'
import './UpdateOnboardingApplication.scss'

/**
 * Component that handles scenarios where the user needs to approve updating the application state.
 */
class UpdateOnboardingApplication extends Component {

  choiceFamilyText = ` To The`

  constructor(props) {
    super(props)

    const user = getSessionItem(SessionConst.USER)
    const hotelCode = this.props.location?.state?.hotelCode
    // The action to be performed will determine the new status of the application
    const action = this.props.location?.state?.action

    if (isObjectEmpty(user) || !hotelCode || !action) {
      // Redirect to home page
      this.props.history.push(RouteConst.ROUTE_HOME_PAGE)
    }

    const isAdminUser = user.isAdmin
    const isHotelContact = user.isHotelContact

    if (!(isAdminUser || isHotelContact)) {
      // Redirect to home page
      this.props.history.push(RouteConst.ROUTE_HOME_PAGE)
    }

    this.state = {
      hotelCode: hotelCode,
      // Basic hotel info used to display information on the page
      basicHotelInfo: this.props.location?.state?.basicHotelInfo,
      // Onboarding status used to update the status of the application
      onboardingStatus: this.props.location?.state?.onboardingStatus,
      action: action,
      loadingMessage: 'Retrieving Hotel Information',
      isLoading: true,
      isAdminUser: isAdminUser,
      isHotelContact: isHotelContact,
      user: user
    }
  }

  /**
   * Lifecylce method that is executed when the component mounts.
   * Retrieves the required information - basic hotel info or onboarding status - based on which one is missing.
   */
  async componentDidMount() {

    if (!this.state.basicHotelInfo) {
      await HotelInfoService.getBasicHotelInfo({
        hotelCode: this.state.hotelCode
      }).then((response) => {
        this.setState({
          basicHotelInfo: response,
          isLoading: false
        })
      }).catch((error) => {
        // Redirect to search page
        this.props.history.push(RouteConst.ROUTE_HOME_PAGE)
      })
    } else if (!this.state.onboardingStatus) {
      await HotelInfoService.getOnboardingStatus({
        hotelCode: this.state.hotelCode
      }).then((response) => {
        this.setState({
          onboardingStatus: response,
          isLoading: false
        })
      }).catch((error) => {
        // Redirect to search page
        this.props.history.push(RouteConst.ROUTE_HOME_PAGE)
      })
    }

  }

  /**
   * Handles the action to start an application.
   * This action is performed when the status needs to change from GENERATED to IN_PROGRESS.
   */
  handleBeginOnboarding = () => {
    const updatedOnboardingStatus = {
      ...this.state.onboardingStatus,
      assignedTo: this.state.user.username,
      status: FormConst.STATUS_IN_PROGRESS
    }
    // Update the status
    this.props.onPut({
      hotelOnboardingId: this.state.onboardingStatus.hotelOnboardingId, formData: updatedOnboardingStatus
    })

    // Show loading modal and set actionPerformed
    // Also update new status, which will be used to passed when 
    // redirecting to the LaunchOnboardingApplication page
    this.setState({
      isLoading: true,
      loadingMessage: 'Begin Onboarding',
      actionPerformed: FormConst.ACTION_START_APPLICATION,
      updatedOnboardingStatus: updatedOnboardingStatus
    })
  }

  /**
   * Handles the action to acquire the lock for the current user.
   * This is used before performing other actions when the user doesn't have the lock.
   * @param {string} nextAction the next action to be performed
   */
  acquireUser = (nextAction) => {

    this.props.acquireUser(this.state.hotelCode)

    // Show loading modal, set actionPerformed and next action
    // Acquire lock is usually followed by some other action
    this.setState({
      isLoading: true,
      loadingMessage: 'Acquiring Lock',
      actionPerformed: FormConst.ACTION_ACQUIRE_USER,
      nextAction: nextAction
    })
  }

  /**
   * Handles the action to start an application.
   * This action is performed when the status needs to change from GENERATED to IN_PROGRESS.
   */
  startReview = () => {
    const updatedOnboardingStatus = {
      ...this.state.onboardingStatus,
      assignedTo: this.state.user.username,
      status: FormConst.STATUS_UNDER_REVIEW
    }
    // Update the status
    this.props.onPut({
      hotelOnboardingId: this.state.onboardingStatus.hotelOnboardingId, formData: updatedOnboardingStatus
    })

    // Show loading modal and set actionPerformed
    // Also update new status, which will be used to passed when 
    // redirecting to the LaunchOnboardingApplication page
    this.setState({
      isLoading: true,
      loadingMessage: 'Starting Review',
      actionPerformed: FormConst.ACTION_START_REVIEW,
      updatedOnboardingStatus: updatedOnboardingStatus
    })
  }

  /**
   * Redirects to the LaunchOnboardingApplication page so that the required info can be set in the session.
   */
  redirectToLaunchOnboardingApplication = () => {
    // Use the updated status if available
    let onboardingStatus = !isObjectEmpty(this.state.updatedOnboardingStatus)
      ? this.state.updatedOnboardingStatus : this.state.onboardingStatus

    // Update the status based on the previous action.
    // This is required because we would've sent an update request before calling this method.
    switch (this.state.actionPerformed) {
      case FormConst.ACTION_START_APPLICATION:
        onboardingStatus.status = FormConst.STATUS_IN_PROGRESS
        break
      case FormConst.ACTION_START_REVIEW:
        onboardingStatus.status = FormConst.STATUS_UNDER_REVIEW
    }

    // Launch the page
    this.props.history.push({
      pathname: RouteConst.ROUTE_LAUNCH_ONBOARDING_APPLICATION_PAGE,
      state: {
        hotelCode: this.state.hotelCode,
        onboardingStatus: onboardingStatus
      }
    })
  }

  /**
   * Lifecycle method which is executed when the component is updated.
   * Handles HTTP response updates only.
   * Dispatches the corresponding action based on the previous action 
   * which caused the component to update.
   * @param {Object} prevProps the previous properties before update
   */
  componentDidUpdate(prevProps) {

    if (prevProps.count !== this.props.count) {
      // Http request completed - Only PUT in this page, so check for response

      if (this.props.errorMessage) {
        this.setState({ isLoading: false, showErrorModal: true })
      } else {
        // When the action is acquire user, call the next action to be perfromed
        if (this.state.actionPerformed === FormConst.ACTION_ACQUIRE_USER) {
          if (this.state.nextAction === FormConst.ACTION_START_REVIEW) {
            this.startReview()
          } else if (this.state.nextAction = FormConst.ACTION_START_APPLICATION) {
            this.handleBeginOnboarding()
          }
        } else {
          // Redirect to Launch Onboarding Application page
          this.redirectToLaunchOnboardingApplication()
        }
      }
    }
  }

  /**
   * Redirects to the search page.
   */
  redirectToSearchPage = () => {
    this.props.history.push(RouteConst.ROUTE_HOME_PAGE)
  }

  render() {

    // Build info to be displayed
    let isEmptyBasicHotelInfo = isEmptyObject(this.state.basicHotelInfo)
    let brandLogo = isEmptyBasicHotelInfo
      ? <></>
      : <img className='brand-logo-img' src={getBrandLogo(this.state.basicHotelInfo)} />

    // Welcome message with hotel details
    let welcomeText = ''
    // Helper text about the action to be performed
    let actionText = ''
    // Corresponding action buttons
    let actionButtons = <></>

    // The action determines the welcome text, action text and action buttons to be displayed.
    switch (this.state.action) {
      case FormConst.ACTION_START_APPLICATION:
        welcomeText =
          <h3 id='update-onboarding-page-welcome-text' className='welcome-text'>
            {`Welcome ${this.state.hotelCode} - ${this.state.basicHotelInfo?.hotelName}`}
            <br />
          to the <img id='update-onboarding-page-choice-logo' src={applogo} className='applogo-img' /> Family
          </h3>
        actionText = <p id='update-onboarding-page-action-text'>
          {
            this.state.isHotelContact
              ? FormConst.START_APPLICATION_TEXT_HOTEL_CONTACT
              : FormConst.START_APPLICATION_TEXT_ADMIN
          }
        </p>
        actionButtons = <div className='action-buttons'>
          <Button
            id='update-onboarding-page-action-button-update'
            name='Begin onboarding'
            role='action'
            onClick={() => this.acquireUser(FormConst.ACTION_START_APPLICATION)} />
          <Button
            id='update-onboarding-page-action-button-continue'
            name='Go To Search Page'
            role='action'
            onClick={this.redirectToSearchPage} />
        </div>
        break
      case FormConst.ACTION_START_REVIEW:
        welcomeText =
          <h3 id='update-onboarding-page-welcome-text' className='welcome-text'>
            {`Welcome ${this.state.hotelCode} - ${this.state.basicHotelInfo?.hotelName}`}
          </h3>
        actionText = <p id='update-onboarding-page-action-text'>
          This application is ready for review. Please select the action you want to perform.
          </p>
        actionButtons = <div className='action-buttons'>
          <Button
            id='update-onboarding-page-action-button-update'
            name='Start Review'
            role='action'
            onClick={() => this.acquireUser(FormConst.ACTION_START_REVIEW)} />
          <Button
            id='update-onboarding-page-action-button-continue'
            name='View Application'
            role='action'
            onClick={this.redirectToLaunchOnboardingApplication} />
        </div>
        break
      case FormConst.ACTION_ACQUIRE_USER:
        welcomeText =
          <h3 id='update-onboarding-page-welcome-text' className='welcome-text'>
            {`Welcome ${this.state.hotelCode} - ${this.state.basicHotelInfo?.hotelName}`}
          </h3>
        actionText = <p id='update-onboarding-page-action-text'>
          The lock to edit this application is acquired by
          {this.state.onboardingStatus ? this.state.onboardingStatus.assignedTo : 'another user'}.
          Do you want to acquire the lock?
          </p>
        actionButtons = <div className='action-buttons'>
          <Button
            id='update-onboarding-page-action-button-update'
            name='Acquire Lock'
            role='action'
            onClick={() => this.acquireUser()} />
          <Button
            id='update-onboarding-page-action-button-continue'
            name='View Application'
            role='action'
            onClick={this.redirectToLaunchOnboardingApplication} />
        </div>
        break
    }

    return (
      <div className='update-onboarding-page'>
        {/* Display page logo, brand logo and welcome text */}
        <img id='update-onboarding-page-logo' src={onboarding} className='update-onboarding-img' />
        {brandLogo}
        {welcomeText}

        {/* Display the actual page content */}
        <div className='update-onboarding-page-content'>
          {actionText}
          {actionButtons}
        </div>

        {/* Form modals */}
        <FormModal
          id='new-onboarding-application-loading-modal'
          title={FormConst.MODAL_UPDATE_ACTION_TITLE}
          hotelInfo={this.state.basicHotelInfo}
          body={<h6>{this.state.loadingMessage}</h6>}
          show={this.state.isLoading}
          isLoadingIndicator />
        <FormModal
          id='new-onboarding-application-error-modal'
          hotelInfo={this.state.basicHotelInfo}
          title={FormConst.MODAL_UPDATE_ACTION_ERROR_TITLE}
          body={<h5>{FormConst.MODAL_UPDATE_ACTION_ERROR_TEXT}</h5>}
          isError
          cancel={() => { this.setState({ showErrorModal: false }) }}
          show={this.state.showErrorModal} />
      </div>
    )
  }
}

// Map redux state to props
const mapStateToProps = state => {
  return {
    onboardingStatusResponse: state.reducer.response,
    errorMessage: state.reducer.errorMessage,
    errorDescription: state.reducer.errorDescription,
    count: state.reducer.count
  }
}

// Map redux dispatch actions to props
const mapDispatchToProps = dispatch => {
  return {
    onPut: (data) => dispatch(asyncMethod(FormConst.FORM_UPDATE_ONBOARDING_NAME, actionTypes.ASYNC_ACTIONS.PUT, data)),
    acquireUser: (hotelCode) => dispatch(asyncMethod(FormConst.FORM_UPDATE_ONBOARDING_NAME, actionTypes.ASYNC_ACTIONS.ACQUIRE_USER, { hotelCode: hotelCode })),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(UpdateOnboardingApplication)